import React from 'react'
import { TABLA_CODIGO_DE_CUPOS } from '../../../../../config/tables'
import MuiTable from '../../../../Forms/SharedComponents/containers/MuiTable'
import TotalizadorCodigosDeCupo from './TotalizadorCodigosDeCupo'

function TablaConsultaCodigoDeCuposView (props) {
  const { codigosDeCupo = null } = props

  return (
    <>
      {codigosDeCupo && codigosDeCupo.length > 0 && <TotalizadorCodigosDeCupo codigosDeCupo={codigosDeCupo} /> }
      <MuiTable id={TABLA_CODIGO_DE_CUPOS} />
    </>
  )
}

export default TablaConsultaCodigoDeCuposView
